import Page from 'modules/app/components/Page';
import React, { useState } from 'react';
import s from './SalonFilter.module.scss';
import Selector from './Selector';
import PriceRange from './PriceRange';
import Switcher from './Switcher';
import useGetMenuCategories from 'sdk/hooks/salon/useGetMenuCategories';
import clsx from 'clsx';
import Button from 'components/shared/Button';
import useGetCities from 'sdk/hooks/salon/useGetCities';
import { ReactComponent as ArrowGoBack } from 'images/new-icons/arrow-go-back.svg';
import { ReactComponent as Search } from 'images/new-icons/search-filter.svg';
import { useActions } from 'store/useActions';
import { useTranslation } from 'react-i18next';

const mapToOptions = data =>
  data?.map(item => ({
    label: item?.name,
    value: item?.id,
  }));

const SalonFilter = ({
  open,
  setShowFilter,
  setSelectedMenuCategory,
  setMinPrice,
  setMaxPrice,
  setTab,
  serviceTypeTabs,
  maxPrice,
  setIsAvailable,
  isAvailable,
  setCityId,
  setShowSearchHistory,
  setIsSearchActive,
  setRating,
}) => {
  const {t} = useTranslation() as any
  const { data: menuCategories } = useGetMenuCategories();
  const { data: cities } = useGetCities();

  const [selectedService, setSelectedService] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedRating, setSelectedRating] = useState(null);
  const { setIsButtonMenuVisible } = useActions();

  const options = [{ name: 'Services', placeholder: 'Select service', data: menuCategories }];

  const secondOptions = [
    { name: 'Location', placeholder: 'Select service', data: cities },
    {
      name: 'Rating',
      placeholder: 'Select rating',
      data: [
        {
          name: '1',
          id: 1,
        },
        {
          name: '2',
          id: 2,
        },
        {
          name: '3',
          id: 3,
        },
        {
          name: '4',
          id: 4,
        },
        {
          name: '5',
          id: 5,
        },
      ],
    },
  ];

  const handleSelector = (value, name) => {
    switch (name) {
      case 'Services':
        setSelectedService(value);
        setSelectedMenuCategory(value);
        break;
      case 'Location':
        setSelectedCity(value);
        setCityId(value);
        break;
      case 'Rating':
        setSelectedRating(value);
        setRating(value);
        break;
      default:
        console.log('default');
    }
  };

  const handleClearAll = () => {
    setSelectedService(null);
    setSelectedMenuCategory(null);
    setMinPrice(undefined);
    setMaxPrice(undefined);
    setSelectedCity(null);
    setCityId(undefined);
    setTab(serviceTypeTabs?.[0]?.id);
    setRating(0);
    setSelectedRating(null);
  };

  return (
    <div className={clsx(s.container, open ? s.container_show : '')}>
      <Page activeLink="/venues">
        <div className={s.filters_header}>
          <ArrowGoBack
            onClick={() => {
              setShowSearchHistory(false);
              setIsSearchActive(true);
              setShowFilter(false);
              setIsButtonMenuVisible(true);
            }}
          />
          <div className={s.filters_header_title}>{t('Filters')}</div>
        </div>
        <div className={clsx(s.filters)}>
          {options.map(({ name, placeholder, data }) => {
            let value = null;

            if (name === 'Services') value = selectedService;

            return (
              <Selector
                key={name}
                name={name}
                placeholder={placeholder}
                options={mapToOptions(data)}
                value={mapToOptions(data)?.find(option => option.value === value) || null}
                onChange={e => handleSelector(e.value, name)}
              />
            );
          })}
          <div className={s.selector_left}>{t('Price range')}</div>
          <PriceRange setMaxPrice={setMaxPrice} maxPrice={maxPrice} />
          {secondOptions.map(({ name, placeholder, data }) => {
            let value = null;

            if (name === 'Location') value = selectedCity;
            if (name === 'Rating') value = selectedRating;

            return (
              <Selector
                key={name}
                name={name}
                placeholder={placeholder}
                options={mapToOptions(data)}
                value={mapToOptions(data)?.find(option => option.value === value) || null}
                onChange={e => handleSelector(e.value, name)}
              />
            );
          })}

          <Switcher isAvailable={isAvailable} setIsAvailable={setIsAvailable} />

          <div className={s.clear_all}>
            <Button className={s.clear_all_clear_button} wide onClick={handleClearAll}>
              {t('Clear All')}
            </Button>
            <Button
              wide
              onClick={() => {
                setShowSearchHistory(false);
                setIsSearchActive(true);
                setShowFilter(false);
                setIsButtonMenuVisible(true);
              }}
              ligtGrey
            >
              <Search /> {t('Search')}
            </Button>
          </div>
        </div>
      </Page>
    </div>
  );
};

export default SalonFilter;
